(()=>{
  function init(){
    const root=document.querySelector('[data-hfd]');
    if(!root||root.dataset.step4PreserveReady)return;
    root.dataset.step4PreserveReady='1';

    function bind(lineColor){
      const lineColorValue=lineColor.closest('[data-hfd-side]')?.querySelector('[data-line-color-value]')||root.querySelector('[data-line-color-value]');
      const colorControl=lineColor.closest('.hfd__color-control');
      if(!colorControl)return;

      function syncSwatches(){
        const active=String(lineColor.value||'#087df5').toLowerCase();
        colorControl.querySelectorAll('[data-line-color-swatch]').forEach(button=>{
          const selected=button.dataset.lineColorSwatch.toLowerCase()===active;
          button.classList.toggle('is-active',selected);
          button.setAttribute('aria-pressed',selected?'true':'false');
        });
        if(lineColorValue)lineColorValue.textContent=String(lineColor.value||'#087df5').toUpperCase();
      }

      colorControl.addEventListener('click',e=>{
        const swatch=e.target.closest('[data-line-color-swatch]');
        if(!swatch)return;
        e.preventDefault();
        lineColor.value=swatch.dataset.lineColorSwatch;
        lineColor.dispatchEvent(new Event('input',{bubbles:true}));
        lineColor.dispatchEvent(new Event('change',{bubbles:true}));
        syncSwatches();
      });

      lineColor.addEventListener('input',syncSwatches);
      syncSwatches();
    }

    root.querySelectorAll('[data-line-color]').forEach(bind);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
